(() => {
  if (window.BmgMobileMenuController) {
    window.BmgMobileMenuController.initialize();
    return;
  }
  const controllers = new WeakMap();
  const lockClasses = ['bmg-mobile-menu-open', 'bmg-digital-menu-open', 'bmg-physical-menu-open'];

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-bmg-mobile-drawer]').forEach((drawer) => {
      if (controllers.has(drawer)) return;
      const root = drawer.closest('[data-bmg-menu-root]') || drawer.parentElement;
      const toggle = root?.querySelector('[data-bmg-menu-toggle]');
      const closeButton = drawer.querySelector('[data-bmg-menu-close]');
      if (!root || !toggle) return;

      const controller = new AbortController();
      const { signal } = controller;
      const lockClass = drawer.dataset.bmgMenuLockClass || 'bmg-mobile-menu-open';
      const items = () => [...drawer.querySelectorAll('a, button')];
      let open = false;

      const setTabs = (enabled) => items().forEach((item) => { item.tabIndex = enabled ? 0 : -1; });
      const restoreScroll = () => {
        lockClasses.forEach((className) => document.body.classList.remove(className));
        document.documentElement.classList.remove('bmg-menu-open', 'drawer-open');
        document.body.classList.remove('bmg-menu-open', 'drawer-open', 'menu-open');
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      };
      const close = (returnFocus = false) => {
        open = false;
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open navigation menu');
        setTabs(false);
        restoreScroll();
        if (returnFocus && document.contains(toggle)) toggle.focus({ preventScroll: true });
      };
      const show = () => {
        if (open) return;
        open = true;
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-label', 'Close navigation menu');
        setTabs(true);
        document.body.classList.add(lockClass);
        requestAnimationFrame(() => closeButton?.focus({ preventScroll: true }));
      };

      close();
      toggle.addEventListener('click', () => open ? close(true) : show(), { signal });
      closeButton?.addEventListener('click', () => close(true), { signal });
      drawer.addEventListener('click', (event) => {
        if (event.target.closest('a')) close();
        else if (event.target === drawer || event.target.closest('[data-bmg-menu-overlay]')) close(true);
      }, { signal });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && open) { event.preventDefault(); close(true); }
      }, { signal });
      addEventListener('resize', () => { if (innerWidth > 1160 && open) close(); }, { passive: true, signal });
      addEventListener('pagehide', () => close(), { signal });
      controllers.set(drawer, { close, destroy: () => { close(); controller.abort(); controllers.delete(drawer); } });
    });
  };

  window.BmgMobileMenuController = { initialize };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll?.('[data-bmg-mobile-drawer]').forEach((drawer) => controllers.get(drawer)?.destroy());
  });
})();
